import {
  IconCalendar,
  IconRefresh,
  IconSoup,
  IconTicket,
  IconTruck,
} from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

const BENEFITS = [
  { key: "menu", Icon: IconSoup },
  { key: "extendDiet", Icon: IconRefresh },
  { key: "manageDelivery", Icon: IconTruck },
  { key: "rescheduleDiet", Icon: IconCalendar },
  { key: "collectDiscounts", Icon: IconTicket },
] as const;

/**
 * "Załóż konto i ciesz się korzyściami!" — shown beside the form on the
 * sign-in page and below it inside the auth dialog.
 */
export const AccountBenefitsList = ({ className }: { className?: string }) => {
  const t = useTranslations("auth.benefits");

  return (
    <div className={cn("flex flex-col gap-6", className)}>
      <h2 className="font-medium text-text text-xl leading-8 md:text-2xl">
        {t("title")}
      </h2>
      <ul className="flex flex-col gap-5">
        {BENEFITS.map(({ key, Icon }) => (
          <li
            className="flex items-center gap-4 rounded-xl bg-background-surface-primary px-4 py-4"
            key={key}
          >
            <Icon
              aria-hidden="true"
              className="size-8 shrink-0 text-brand-yellow-300"
              stroke={1.5}
            />
            <span className="font-medium text-base text-text leading-6">
              {t(key)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
